import { useEffect } from "react"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import {
  createRootRoute,
  Outlet,
  ScrollRestoration,
} from "@tanstack/react-router"

import { Toaster } from "@/components/ui/toaster"
import { TooltipProvider } from "@/components/ui/tooltip"
import { EmbedProvider } from "@/components/context/embed-context"
import { ThemeProvider, useTheme } from "@/components/context/theme-provider"

import NotFound from "./not-found"

const queryClient = new QueryClient()

// Inner component to access theme setter
function ThemeMessageListener({ children }: { children: React.ReactNode }) {
  const { setTheme } = useTheme()

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === "THEME_CHANGE") {
        const { theme } = event.data
        console.log("📨 Water received theme:", theme)
        setTheme(theme)
      }
    }
    window.addEventListener("message", handleMessage)
    return () => window.removeEventListener("message", handleMessage)
  }, [setTheme])

  return <>{children}</>
}

export const Route = createRootRoute({
  component: () => (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider defaultTheme="system" storageKey="vite-ui-theme">
        <TooltipProvider>
          <EmbedProvider>
            <ThemeMessageListener>
              <div
                vaul-drawer-wrapper=""
                className="overflow-x-hidden antialiased"
              >
                <ScrollRestoration />
                <Outlet />
              </div>
              <Toaster />
            </ThemeMessageListener>
          </EmbedProvider>
        </TooltipProvider>
      </ThemeProvider>
    </QueryClientProvider>
  ),
  notFoundComponent: () => <NotFound />,
})
